import styled from 'styled-components';
import { IconChevronDown, Type, TextLink, IconChevronRight, white, black, blue100, spacer16, spacer12, spacer8, spacer4, spacer20, screenSmMin, gray70, desktopCelloCanon, desktopBallad, desktopViola, screenXsMin, } from '@spotify-internal/encore-web';
import { default as BaseContainer } from '../../atoms/Container';
const iconSize = '32px';
export const Container = styled(BaseContainer) `
  margin: 0 auto;

  > * {
    max-width: 610px;
  }
`;
export const HeadingContainer = styled.div `
  text-align: left;
  padding: 0 0 ${spacer8} 0;
`;
export const ListContainer = styled.ul `
  margin: 0;
  padding: 0 0 ${spacer8} 0;
  list-style: none;

  @media (min-width: ${screenXsMin}) {
    padding: 0 0 ${spacer20} 0;
  }
`;
export const PlanBanner = styled.div `
  display: flex;
  box-sizing: border-box;
  background: ${black};
  color: ${white};
  padding: ${spacer8} ${spacer16};
  margin-top: ${spacer8};
  width: 100%;
  border-radius: 8px 8px 0px 0px;
  text-transform: uppercase;
`;
export const StyledChevron = styled(IconChevronDown) `
  vertical-align: middle;
  width: ${iconSize};
  height: ${iconSize};
`;
export const Card = styled.article `
  margin: 0 auto ${spacer8};
  padding: 0;
  border: 1px solid ${gray70};
  box-sizing: border-box;
  border-radius: 8px;
  background: ${white};

  ${PlanBanner} + & {
    border-radius: 0 0 10px 10px;
  }

  @media (min-width: ${screenSmMin}) {
    padding: 0;
  }

  &[open] ${StyledChevron} {
    transform: rotate(180deg);
  }

  &:hover,
  &:focus-within {
    border: 1px solid ${black};
  }

  &[open]:focus-within {
    box-shadow: 0 0 0 1px ${black};
  }
`;
export const PlansTitle = styled(Type.h2) `
  margin: ${spacer16} 0 ${spacer12};
  padding: 0;
  font: ${desktopCelloCanon};
`;
export const Drawer = styled.ul `
  margin: 0;
  padding: 0 ${spacer20} ${spacer16} ${spacer20};
  list-style: none;
  border-top: none;
`;
export const PaymentChevron = styled(IconChevronRight) `
  vertical-align: middle;
  width: ${iconSize};
  height: ${iconSize};
  padding: ${spacer20} ${spacer16} ${spacer20} 23px;

  ${({ textDirection }) => textDirection === 'rtl' ? `transform: rotate(180deg);` : ''};
`;
export const PaymentOption = styled(TextLink) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${gray70};
  border-radius: 4px;
  padding: ${spacer16} 0 ${spacer16} ${spacer16};
  text-decoration: none;
  color: inherit;
  margin-bottom: ${spacer8};
  background: ${white};

  &:hover:not([disabled]):not([disabled]) {
    border: 1px solid ${black};
    text-decoration: none;
    color: ${black};
  }

  &[href]:focus:not([disabled]) {
    box-shadow: none;
    transition: none;
  }

  &[href]:focus-visible:not([disabled]) {
    border: 1px solid transparent;
    box-shadow: 0 0 0 2px ${black};
  }
`;
export const PaymentMethods = styled.ul `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
  padding: 0;
`;
export const PaymentMethod = styled.img `
  margin: 0 ${spacer4} ${spacer4} 0;
  max-width: 120px;
  height: 24px;
`;
export const HeaderArea = styled.div `
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - ${iconSize});
`;
export const PlanHeaderTitle = styled(Type.h2) `
  margin: 0;
  padding: 0;
  font-size: ${desktopBallad.fontSize};
`;
export const PlanHeader = styled.div `
  padding: ${spacer16};

  @media (min-width: ${screenSmMin}) {
    padding: ${spacer16} ${spacer20};
  }

  [data-selectable-plan='true'] & {
    cursor: pointer;

    list-style: none;
    &::-webkit-details-marker {
      display: none;
    }

    outline: none;

    &:focus-visible {
      border-radius: 8px;
      box-shadow: 0 0 0 2px ${black};
    }
  }

  [open] &:focus-visible {
    box-shadow: none;
  }
`;
export const PlanHeaderSubtitle = styled(Type.p) `
  margin: 5px 0 0 0;
  padding: 0;
  font-size: ${desktopBallad.fontSize};
`;
export const Promotion = styled(Type) `
  color: ${white};
  background-color: ${blue100};
  border-radius: 4px;
  padding: ${spacer4} ${spacer8};
  display: inline-block;
  margin-bottom: ${spacer8};
  font-size: ${desktopViola.fontSize};

  margin-block-start: 0;
  margin-block-end: ${spacer8};
`;
//# sourceMappingURL=components.js.map